
/*
 * Date: 2025
 * Description: Reusable table remastered
 * Author: Philippe Leroux @ Skitsc
 */

//Modules
import { ReactElement } from "react";
import { Box } from "@mui/material";

//Interfaces
import { i_table_props } from "../../interfaces/utility.interface";

//Components
import Header from "./header";
import TablePaginationV2 from "./pagination";
import UserRow from "../rows/user.rows";
import RunsRow from "../rows/runs.rows";
import ScriptsRows from "../rows/scripts.rows";
import ArchivesRows from "../rows/archive.rows";


const Tbl = ( props : i_table_props ) : ReactElement => {
    return (
        <Box>
            {props.data.length > 0 ?
                <Box>
                    <Header headers={props.headers}/>
                         {  props.data.map(( row : any , index : number) => (
                            <Box key={index}>
                                { props.row_model === 'user' &&
                                    <UserRow row={row} {...props}/>
                                }
                                {
                                    props.row_model === 'runs' &&
                                    <RunsRow row={row} {...props} />
                                }
                                { props.row_model === 'scripts' &&
                                    <ScriptsRows row={row} {...props} />
                                    
                                }
                                {
                                    props.row_model === 'archives' && 
                                    <ArchivesRows row={row} {...props} />
                                }
                            </Box>
                        ))}
                    {props.pagination !== undefined &&
                        <TablePaginationV2 {...props.pagination} />
                    }
                </Box>
            :
            <Box sx={{ padding : "24px" , border : '1px solid gray' , fontSize : '22px', margin: '4%'}}>
                {props.title}
            </Box>
            }
        </Box>
    )

}

export default Tbl;